export default function ServiceKeypoint({service}) {
  return (
    <>
    <section className="service-keypoint">
        <div className="container">
            <div className="row">
             
                <div className='col-lg-12'>
                    <div className="vector-heading">
                        <img src="./assets/home/shape-vector.png" alt="vector"/>
                        <h4 className="heading">key points</h4>
                    </div>
                </div>
                {service?.keypoints?.map((keyPoint, index) => (
                <div className='col-lg-3 col-md-6 wow animate__animated animate__slideInUp' key={index} data-wow-duration={`${1 + index * 0.1}s`}>
                    <div className='keypoint-box'>
                        <span>{keyPoint.title}</span>
                        <p>{keyPoint.description}</p>
                        {/* <span>Personalized</span>
                        <p>Interia’s excellence is observed in interior projects where personalized styles and client preferences are always taken into consideration.</p> */}
                    </div>
                </div>
                ))}

                {/* <div className='col-lg-3 col-md-6 wow animate__animated animate__slideInUp' data-wow-duration="1.1s" data-wow-delay="0.1s">
                    <div className='keypoint-box'>
                        <span>Functionality</span>
                        <p>Our best interior designers in Gurgaon create beautiful spaces made with thoughtfully picked decor, space layout, and aesthetic appeal.</p>
                    </div>
                </div>

                <div className='col-lg-3 col-md-6 wow animate__animated animate__slideInUp' data-wow-duration="1.2s" data-wow-delay="0.2s">
                    <div className='keypoint-box'>
                        <span>Spaciousness</span>
                        <p>Interia, being one of the top home interior designers in Gurgaon, promotes a sense of freedom and peace through space maximization.</p>
                    </div>
                </div>

                <div className='col-lg-3 col-md-6 wow animate__animated animate__slideInUp' data-wow-duration="1.3s" data-wow-delay="0.3s">
                    <div className='keypoint-box'>
                        <span>Timeless Elegance</span>
                        <p>We aim for designs that combine modern luxury with enduring appeal, ensuring your space remains beautiful for years to come.</p>
                    </div>
                </div> */}

            </div>
        </div>
    </section>
    </>
  )
}
